import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, Events } from '@ionic/angular';
import { EventEmitterService } from '../services/event-emitter.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UsuarioProvider } from './usuario.provider';

@Injectable()
export class MenuProvider {

    private appPagesResponsavel = [
        {
            title: 'Cadastro',
            url: '/estabelecimentos/rascunhos',
            icon: '/assets/custom-icons/cadastro.svg'
        }, {
            title: 'Em Análise',
            url: '/estabelecimentos/analise',
            icon: '/assets/custom-icons/analise.svg'
        }
        /*{
            title: 'Entidades Administradoras',
            url: '/estabelecimentos/entidades',
            icon: '/assets/custom-icons/cadastro.svg'
        }*/
    ];

    private appPagesOutro = [
        {
            title: 'Suporte CNES',
            url: 'https://webatendimento.saude.gov.br/faq/cnes',
            icon: '/assets/custom-icons/ajuda.svg',
        },
        {
            title: 'Wiki',
            url: 'https://wiki.saude.gov.br/cnes/index.php/P%C3%A1gina_principal',
            icon: '/assets/custom-icons/doc.svg',
        },
        {
            title: 'Notificações',
            url: '/notificacoes',
            icon: '/assets/custom-icons/aviso.svg',
            aviso: true,
            avisoLabel: 0
        },
        // {
        //     title: 'Configuração',
        //     url: '/',
        //     icon: '/assets/custom-icons/configuracao.svg'
        // }
    ];

    public optComponent: string;

    constructor(
        private router: Router,
        private events: Events,
        private alertController: AlertController,
        private usuarioProvider: UsuarioProvider,
        private notificacaoService: NotificacaoService
    ) {
        this.carregarNotificacoes();
        this.subscribeEvents();
    }

    async carregarNotificacoes() {
        this.notificacaoService.quantidadeNovas$.subscribe(n => {
            this.appPagesOutros[2].avisoLabel = n;
        });
    }

    subscribeEvents() {
        this.events.subscribe(EventEmitterService.EVENTOS.NOTIFICATION_READ, () => {
            this.appPagesOutros[2].avisoLabel--;
            if (this.appPagesOutros[2].avisoLabel === 0) {
                this.appPagesOutros[2].aviso = false;
            }
        });
    }
    get appPagesOutros() {
        return this.appPagesOutro;
    }

    get appMenuGestor() {
        if (this.usuarioProvider.getUsuario().menu) {
            const menuGestor: any = this.usuarioProvider.getUsuario().menu.filter((m) => {
                return m.descricao === 'Gestão';
            })[0];
            menuGestor.itens.forEach((i) => {
                i.title = i.descricao;
                i.url = i.path;
                i.icon = this.getIcone(i.title);
            });
            return menuGestor.itens;
        }
    }

    get appPages() {
        if (this.usuarioProvider.getUsuario().menu) {
            const menuEstabelecimento: any = this.usuarioProvider.getUsuario().menu.filter((m) => {
                return m.descricao !== 'Gestão';
            });
            menuEstabelecimento.forEach((i) => {
                delete i.itens;
                i.title = i.descricao;
                i.url = i.descricao.toLowerCase() === 'cadastro' ? '/estabelecimentos/rascunhos'
                    : (i.descricao.toLowerCase() === 'análise' ? '/estabelecimentos/analise'
                        : (i.descricao.toLowerCase() === 'entidades administradoras' ? '/estabelecimentos/entidades' : i.path));
                i.icon = i.descricao.toLowerCase() === 'cadastro' ? '/assets/custom-icons/cadastro.svg'
                    : (i.descricao.toLowerCase() === 'análise' ? '/assets/custom-icons/analise.svg'
                        : (i.descricao.toLowerCase() === 'entidades administradoras' ? '/assets/custom-icons/cadastro.svg' : this.getIcone(i.title)));
            });
            return menuEstabelecimento;
        }
    }

    getIcone(descricao: string) {
        descricao = descricao.toLowerCase();
        if (descricao === 'painel de monitoramento' || descricao === 'marcações'
            || descricao === 'entidades administradoras' || descricao === 'gerar competência') {
            return '/assets/custom-icons/cadastro.svg';
        }
        else if (descricao === 'desativação/reativação' || descricao === 'análise') {
            return '/assets/custom-icons/analise.svg';
        } else if (descricao === 'equipes (ine)' || descricao === 'profissionais impedidos'
            || descricao === 'solicitações de desligamento' || descricao === 'troca de gestão') {
            return '/assets/custom-icons/ico-equipe-ine.svg';
        }
    }

    async logout() {
        const alert = await this.alertController.create({
            header: 'Atenção!',
            message: 'Deseja sair com segurança?',
            mode: 'ios',
            buttons: [{
                text: 'Cancelar',
                role: 'cancel',
                cssClass: 'secondary'
            }, {
                text: 'Confirmar',
                handler: async () => {
                    await this.router.navigate(['/login']);
                    this.usuarioProvider.setUsuario(null);
                }
            }]
        });

        await alert.present();
    }

    setPage(page: any) {
        if(page.url && page.url.includes('http')) {
            window.open(page.url, '_blank')
            return;
        }
        this.optComponent = page.title;
        this.router.navigate([page.url], {
            state: page
        });
    }

}
